<app-progress-indicator [inProgress]="isLoading"></app-progress-indicator>
<div class="wintersport-wetter-container">
  <h3>Wintersportwetter Texte ({{wintersportWetterTexte?.update}})</h3>
  <div *ngFor="let regionen of wintersportWetterTexte?.regionen">
    <div class="wintersport-wetter-border-container">
      <span class="wintersport-wetter-subtitle">{{regionen.name}}</span>
      <div *ngIf="regionen.prognose">
        <!--  <span class="wintersport-wetter-subtitle">Prognose</span> -->
        <p class="wintersport-wetter-paragraph" [innerHTML]="regionen?.prognose?.ausspiel"></p>
        <p class="wintersport-wetter-paragraph" [innerHTML]="regionen?.prognose?.text"></p>
      </div>
      <div *ngIf="regionen.schneelage">
        <!--      <span class="wintersport-wetter-subtitle">Schneelage</span> -->
        <p class="wintersport-wetter-paragraph" [innerHTML]="regionen?.schneelage?.ausspiel"></p>
        <p class="wintersport-wetter-paragraph" [innerHTML]="regionen?.schneelage?.text"></p>
      </div>
    </div>
  </div>
</div>
